const EventsByTypeChart = (data = [
  { label: 'Webinar', count: 12 },
  { label: 'Concert', count: 6 },
  { label: 'Meetup', count: 9 }
]) => {
  // ✅ Safely handle array and calculate total
  const safeData = Array.isArray(data) ? data : [];
  const totalCount = safeData.reduce((sum, item) => sum + (item.count || 0), 0);

  return {
    title: {
      text: `${totalCount}`,
      subtext: 'Total',
      left: '49%',
      top: '45%',
      textAlign: 'center',
      textVerticalAlign: 'middle',
      textStyle: {
        fontSize: 26,
        fontWeight: 'bold',
        fontFamily: 'Inter, Poppins, sans-serif',
        color: '#333'
      },
      subtextStyle: {
        fontSize: 14,
        color: '#888',
        fontFamily: 'Inter, Poppins, sans-serif'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: params => {
        const { name, value, percent } = params;
        return `<b>${name}</b><br/>🎟️ Count: ${value}<br/>📊 Percent: ${percent}%`;
      }
    },
    legend: { show: false },
    series: [
      {
        name: 'Event Type',
        type: 'pie',
        radius: ['35%', '65%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 8,
          borderColor: '#fff',
          borderWidth: 4
        },
        label: {
          show: true,
          position: 'outside',
          // 👇 moves percent below
          formatter: params => `${params.name}: ${params.value}\n(Percent: ${params.percent}%)`,
          fontSize: 12,
          fontFamily: 'Inter, Poppins, sans-serif',
          color: '#444',
          lineHeight: 16
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
          lineStyle: {
            color: '#aaa'
          }
        },
        data: safeData.map(item => ({
          name: item.label,
          value: item.count
        }))
      }
    ]
  };
};

export default EventsByTypeChart;
